import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { JsonApiService } from './api/json-api.service'
import { LayoutService } from '../shared/layout/layout.service'
import { UserService } from '../shared/user/user.service'
import { VoiceControlService } from '../shared/voice-control/voice-control.service'
import { SoundService } from '../shared/sound/sound.service';
import { AuthGuard } from './guards/auth.guard';
import { HomeResolver } from './guards/home.resolver';
import { SessionInterceptor } from './interceptors/session.interceptor';

import { throwIfAlreadyLoaded } from './guards/module-import-guard';
import { VoiceRecognitionService } from '../shared/voice-control/voice-recognition.service';
import { TabsModule, ProgressbarModule, TooltipModule, BsDropdownModule, AlertModule } from 'ngx-bootstrap';
import { AdminGuard } from './guards/admin.guard';
import { RfaGuard } from './guards/rfa.guard';
import { AgentGuard } from './guards/agent.guard';
import { BillingGuard } from './guards/billing.guard';
import { AdminPOSGuard } from './guards/admin-pos.guard';
import { BillingPlusAPosGuard } from './guards/billing-apos.guard';
import { BillingModifiedGuard } from './guards/billing_modified.guard';
import { RsSupervisorGuard } from './guards/rs-supervisor';

@NgModule({
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot(),
    ProgressbarModule.forRoot(),
    AlertModule.forRoot(),
    TabsModule.forRoot(),
  ],
  exports: [
    HttpClientModule
  ],
  declarations: [],
  providers: [
    JsonApiService,
    LayoutService,
    UserService,
    VoiceControlService,
    VoiceRecognitionService,
    SoundService,
    AuthGuard,
    HomeResolver,
    AdminGuard,
    RfaGuard,
    BillingGuard,
    BillingModifiedGuard,
    AgentGuard,
    AdminPOSGuard,
    BillingPlusAPosGuard,
    RsSupervisorGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionInterceptor,
      multi: true
    }
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts